import React from "react";
import { connect } from "react-redux";
import { firebaseDb, firebaseApp } from "../../../core/firebase";
import Users from "./sections/users";
// import Affiliate from "./sections/affiliate";
import Logo from "../../components/logo";
import hamburger from "./hamburger.png";
import close from "./close.png";
import usersBlue from "./users-blue.png";
import usersWhite from "./users-white.png";
import "./styles.css";

class Admin extends React.Component {
  state = {
    admin: null,
    idToken: null,
    currentSection: "Users",
    sidenavOpen: false,
  };

  componentDidUpdate() {
    if (this.props.user.uid && this.state.admin === null) {
      firebaseDb
        .ref(`/user/${this.props.user.uid}/admin`)
        .once("value", (snapshot) => {
          if (snapshot.val() === true) {
            this.setState({ admin: true });
            firebaseApp
              .auth()
              .currentUser.getToken(/* forceRefresh */ true)
              .then((idToken) => {
                this.setState({ idToken });
              })
              .catch(function (error) {
                console.log(error);
              });
          } else {
            this.setState({ admin: false });
          }
        });
    }
  }

  render() {
    const { currentSection, admin } = this.state;
    const { displayName, photoURL } = this.props.user;
    if (admin === true) {
      return (
        <div className="admin">
          <div className="topbar">
            <img
              src={hamburger}
              alt="Menu"
              onClick={() => this.setState({ sidenavOpen: true })}
            />
            <div>{currentSection}</div>
          </div>
          <div
            className={
              this.state.sidenavOpen ? "blackoverlay visible" : "blackoverlay"
            }
          />
          <div
            className={this.state.sidenavOpen ? "sidenav" : "sidenav closed"}
          >
            <div className="top">
              <div
                className="closenav"
                onClick={() => this.setState({ sidenavOpen: false })}
              >
                <img src={close} alt="close icon" />
              </div>
              <Logo />
              <span>Admin</span>
            </div>
            <div className="nav">
              <div
                onClick={() =>
                  this.setState({ currentSection: "Users", sidenavOpen: false })
                }
                className={
                  currentSection === "Users" ? "navitem active" : "navitem"
                }
              >
                <img
                  src={currentSection === "Users" ? usersBlue : usersWhite}
                  alt="user icon"
                />
                Users
              </div>
              {/* <div
                onClick={() =>
                  this.setState({
                    currentSection: "Affiliate",
                    sidenavOpen: false
                  })
                }
                className={
                  currentSection === "Affiliate" ? "navitem active" : "navitem"
                }
              >
                <img
                  src={
                    currentSection === "Affiliate"
                      ? affiliateBlue
                      : affiliateWhite
                  }
                />Affiliate
              </div> */}
            </div>
          </div>
          <div className="contentarea">
            <div className="userbar">
              <div className="photoandname">
                <img src={photoURL} alt="avatar" />
                <span>{displayName}</span>
              </div>
            </div>
            {this.state.idToken ? (
              <div className="content">
                {currentSection === "Users" && (
                  <Users idToken={this.state.idToken} />
                )}

                {/* {currentSection === "Affiliate" && (
                  <Affiliate idToken={this.state.idToken} />
                )} */}
              </div>
            ) : null}
          </div>
        </div>
      );
    } else if (admin === false) {
      return <h2>You are not an admin!</h2>;
    } else {
      return <h3>Please wait...</h3>;
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Admin);



/** WEBPACK FOOTER **
 ** ./src/views/pages/admin/index.js
 **/